import { SuitUIButton } from '../../../../components/SuitUIButton';

export interface dashboardcardsProps {
    text: string;
    onClick: () => void;
    actionText: string;
    className: string;
}

const Dashboardcards = ({
    text,
    onClick,
    actionText,
    className
}: dashboardcardsProps) => {
    return (
        <div
            className={`min-w-[269px] h-[156px] flex flex-col justify-center  px-[24px] py-[14px] rounded-[24px] ${className}`}
        >
            <p className='text-base leading-[24px] font-normal lg:font-normal mb-[16px] text-black '>
                {text}
            </p>
            <div>
                <SuitUIButton
                    text={actionText}
                    onClick={onClick}
                    style='rounded-[8px] text-white text-sm bg-[#001B23] border border-[#001B23] shadow-[0px 1px 2px 0px #1018280D] h-[36px] px-[16px]'
                    variant='secondary'
                />
            </div>
        </div>
    );
};

export default Dashboardcards;
